import React, { useState } from 'react'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  List,
  ListItem,
  ListItemText,
  TextField,
} from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import type { RootState } from 'reducers'

import { logout } from 'actions/auth-actions'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { post } from 'utils/http'

type MfaQrCodeProps = {
  mfaKey: string
  qrCode: string
}

const MfaQrCode = ({ qrCode, mfaKey }: MfaQrCodeProps) => {
  const [code, setCode] = useState<string>()
  const queryClient = useQueryClient()
  const d = useAppDispatch()
  const userId = useSelector((s: RootState) => s.app.user.id)

  const handleCodeChange = (ev: any) => setCode(ev.target.value)

  const handleVerifyClick = async () => {
    await post(`/management/auth/users/${userId}/mfa_verify`, { code, key: mfaKey })
    await queryClient.invalidateQueries({ queryKey: ['mfa_setup'] })
    d(logout())
  }

  return (
    <Card>
      <CardHeader title="Multi-factor Authentication" />
      <CardContent>
        <Grid container>
          <Grid
            size={{
              sm: 6,
              xs: 12,
            }}>
            <div>
              <img alt="MFA QR code" src={qrCode} />
            </div>
            <TextField
              label="One-time code"
              name="code"
              onChange={handleCodeChange}
              placeholder="Enter one-time code"
              value={code}
              variant="outlined"
            />
          </Grid>
          <Grid
            size={{
              sm: 6,
              xs: 12,
            }}>
            <List component="ol">
              {/* eslint-disable max-len */}
              <ListItem>
                <ListItemText primary="1. Make sure you got a compatible authenticator app installed on your phone (e.g. Authy, Google Authenticator)" />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="2. Scan the QR code* on the left with the app (follow your app instructions)"
                  secondary="QR code can take a while to load, reload the page if it does not"
                />
              </ListItem>
              <ListItem>
                <ListItemText primary="3. Verify by providing the one-time password generated by your authenticator app" />
              </ListItem>
              <ListItem>
                <ListItemText primary="4. After clicking VERIFY you will be redirected to login page to securely log in" />
              </ListItem>
              {/* eslint-enable max-len */}
            </List>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Button color="primary" onClick={handleVerifyClick}>
          Verify
        </Button>
      </CardActions>
    </Card>
  )
}

export default MfaQrCode
